var render = function render(){var _vm=this,_c=_vm._self._c;return _c('checkbox',{attrs:{"disabled":_vm.disabled,"label":_vm.label,"value":_vm.hasValue,"input-value":_vm.hasValue},on:{"change":function($event){return _vm.toggleDeleteCheckboxValue()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }